import { Box } from "@caspeco/casper-ui-library.components.box";
import {
	ThemeColorVariable,
	ThemeFontSizeVariable,
	ThemeFontVariable,
	ThemeRadiusVariable,
	ThemeSpaceVariable,
} from "@caspeco/casper-ui-library.base-ui.theme";
import { Heading } from "@caspeco/casper-ui-library.components.heading";
import { Flex } from "@caspeco/casper-ui-library.components.flex";
import { ImageMap } from "types/imageMap";
import { AspectRatio } from "types/ui";
import { Image } from "@caspeco/casper-ui-library.components.image";

interface ICartRowContent {
	name: string;
	addonsElement: JSX.Element | null;
	imageMap: ImageMap;
}

function CartRowContent({ name, addonsElement, imageMap }: ICartRowContent) {
	return (
		<Box flex="1" display="flex" flexDirection="column">
			<Box flexDirection="row">
				<Flex gap={ThemeSpaceVariable.Small} alignItems="center">
					{imageMap.hasImage(AspectRatio.OneByOne) && (
						<Image
							src={imageMap.withSizeQuery(AspectRatio.OneByOne, "m")}
							srcSet={imageMap.getScrSet(AspectRatio.OneByOne, "s", "m")}
							fallback={
								<Box
									w="2.5rem"
									h="2.5rem"
									minW="2.5rem"
									minH="2.5rem"
									borderRadius={ThemeRadiusVariable.Small}
									bg={ThemeColorVariable.BackgroundDisabled}
								/>
							}
							borderRadius={ThemeRadiusVariable.Small}
							h="2.5rem"
							w="2.5rem"
						/>
					)}
					<Heading
						as="h3"
						fontWeight="medium"
						color={ThemeColorVariable.OnSurfaceHeader}
						fontFamily={ThemeFontVariable.SubHeader}
						fontSize={ThemeFontSizeVariable.Medium}
					>
						{name}
					</Heading>
				</Flex>
				{addonsElement}
			</Box>
		</Box>
	);
}

export default CartRowContent;
